import React from 'react';
import Navbar from '../../components/Navbar';
import LabelDetail from '../../components/Label/LabelDetail';
import './LabelDetailPage.css';

const LabelDetailpage = () => {
  return (
    <div className="label-detail-page">
      <Navbar />
      <div className="label-detail-content">
        <LabelDetail />
      </div>
    </div>
  );
};

export default LabelDetailpage;
